import { OnChanges, Component, Input, OnInit, Output, SimpleChanges, OnDestroy, ViewChild, ElementRef, EventEmitter } from '@angular/core';
import { ApexOptions } from 'apexcharts';
import { Currency } from 'src/app/models/currency';
import { CryptoPriceData, CryptoPriceDataInfo, PriceChartDuration, PriceDataPoint } from 'src/app/models/price-chart';
import { CryptoPriceService } from 'src/app/services/crypto-price.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'crypto-list-item',
  templateUrl: './crypto-list-item.component.html',
  styleUrls: ['./crypto-list-item.component.scss'],
  providers: [CryptoPriceService]
})
export class CryptoListItemComponent implements OnInit, OnChanges, OnDestroy {
  @Input() currency: Currency;
  @Input() baseCurrencyCode: string;
  @Input() duration: PriceChartDuration;

  @Output() update = new EventEmitter<CryptoPriceData>();

  @ViewChild('chartElm')
  chartElementRef: ElementRef;

  loading = true;

  data: CryptoPriceData;
  pair: string;
  chart: any;

  useGlobalCurrency = !!environment.currencies.globalCurrency;

  constructor(
    private cryptoPriceService: CryptoPriceService
  ) { }

  ngOnInit(): void {
    this.cryptoPriceService.setBaseCurrency(this.baseCurrencyCode);

    this.cryptoPriceService.valueChanges.subscribe(val => {
      this.loading = false;
      this.data = val;
      this.pair = this.cryptoPriceService.pair;

      this.renderChart();

      this.update.next(this.data);
    });

    this.cryptoPriceService.setCurrency(this.currency?.code);
    this.cryptoPriceService.setDuration(this.duration);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.currency?.currentValue && !changes?.currency.firstChange && changes?.currency?.currentValue !== changes?.currency?.previousValue) {
      this.loading = true;
      this.cryptoPriceService.setCurrency(changes?.currency?.currentValue?.code);
    }

    if (changes?.baseCurrencyCode?.currentValue && !changes?.baseCurrencyCode.firstChange && changes?.baseCurrencyCode?.currentValue !== changes?.baseCurrencyCode?.previousValue) {
      this.loading = true;
      this.cryptoPriceService.setBaseCurrency(changes?.baseCurrencyCode?.currentValue);
    }

    if (changes?.duration?.currentValue && !changes?.duration.firstChange && changes?.duration?.currentValue !== changes?.duration?.previousValue) {
      this.loading = true;
      this.cryptoPriceService.setDuration(changes?.duration?.currentValue);
    }
  }

  ngOnDestroy(): void {
    this.chart?.destroy();
  }

  renderChart() {
    const element = this?.chartElementRef?.nativeElement;

    if (!element) {
      return;
    }

    if (!this.chart) {
      this.chart = new ApexCharts(element, this.chartOptions);
      this.chart.render();
    } else {
      this.updateChart();
    }
  }

  updateChart() {
    this.chart?.updateOptions({
      series: [
        {
          data: this.data?.priceHistory?.defaultCurrencyData?.data,
        }
      ],
      colors: [this.data?.chartColor],
    });
  }

  get chartOptions(): ApexOptions {
    return {
      chart: {
        redrawOnWindowResize: false,
        parentHeightOffset: 0,
        height: 38,
        type: 'line',
        sparkline: {
          enabled: true,
        },
        animations: {
          enabled: false,
          animateGradually: {
            enabled: false,
          },
        },
      },
      series: [
        {
          data: this.data?.priceHistory?.defaultCurrencyData?.data,
        },
      ],
      colors: [this.data?.chartColor],
      stroke: {
        curve: 'smooth',
        width: 2,
      },
      tooltip: {
        enabled: false,
      },
    };
  }
}
